import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";
import { TIRE_SET_INTRO_SAMPLE } from "ui/modules/fleet/tires/pages/TireSetEditCard/components/TireSetIntro/consts";

import { getDemountNewSet, getDemountVehicle } from "../consts";
import { TireSetDemountSceneProps } from "../types";

/** Korak "Novi set": zamjena na vozilu, novi set dolazi sa skladišta. */
const DemountNewSetScene: React.FC<TireSetDemountSceneProps> = (props) => {
  const { currentSet } = props;
  const vehicle = getDemountVehicle(props);
  const newSet = getDemountNewSet(props);
  const oldCode = currentSet.code || TIRE_SET_INTRO_SAMPLE.code;

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="h-[7rem] rounded-md bg-gradient-to-br from-slate-50 to-slate-100 p-[10px]">
            <img src={vehicle.image} alt="" className="w-full h-full object-contain" />
          </div>
          <div className="mt-3 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Zamjena guma</div>
          <div className="text-sm font-bold text-slate-800 truncate">
            {vehicle.name} · {vehicle.registration}
          </div>
          <div className="mt-2 space-y-2">
            <div className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
              <span className="text-slate-500">Skida se</span>
              <span className="px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-amber-100 text-amber-700 truncate">
                {oldCode}
              </span>
            </div>
            <div className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
              <span className="text-slate-500">Montira se</span>
              <span className="px-2 py-0.5 rounded-full text-[0.65rem] font-semibold bg-emerald-100 text-emerald-700 truncate">
                {newSet.code}
              </span>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="h-[5rem] overflow-hidden">
            <img src={TIRE_SET_INTRO_SAMPLE.image} alt="" className="w-full h-full object-contain scale-[1.35]" />
          </div>
          <div className="mt-3 text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Novi set</div>
          <div className="text-xs font-bold text-slate-800 truncate">{newSet.code}</div>
          {newSet.dimension && <div className="text-[0.65rem] text-slate-400 truncate">{newSet.dimension}</div>}
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Vozilo nikad bez guma"
          subtitle="Skidanje i montaža u jednom koraku"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M17 1l4 4-4 4M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 01-4 4H3" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(DemountNewSetScene);
